export default "__VITE_ASSET__COWGdh5U__"